// extracted by mini-css-extract-plugin
export default {"card":"NPSInfo_card__cxR-V"};